var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper-item"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"border-line"}),_c('div',[_vm._t("title"),(!_vm.titleSlot)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2)]),_c('div',{staticClass:"body",style:(_vm.bodyStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }